export default "/images/2262b3f457ae1d881132ee6700e2c83e.png";